import { Box, Stack } from '@mui/material';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import QueryString from 'qs';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import RHFTextField from '@/app/components/hook-form/rhf-text-field';
import FormProvider from '@/app/components/hook-form/form-provider';
import { encryptRequest, decryptResponse } from '@/app/utilities/helpers/security';
import { axiosInstance } from '@/app/utilities/helpers/axios';

export default function DropMessage() {
  const { enqueueSnackbar } = useSnackbar();

  const Schema = Yup.object().shape({
    email: Yup.string().email('Invalid email address').required('Email is required'),
    name: Yup.string().required('Name is required'),
    phone: Yup.string(),
    macAddress: Yup.string(),
    subject: Yup.string().required('Subject is required'),
    message: Yup.string().required('Message is required'),
  });

  const defaultValues = {
    email: '',
    name: '',
    phone: '',
    macAddress: '',
    subject: '',
    message: '',
  };

  const methods = useForm({
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async data => {
    try {
      const body = {
        data: encryptRequest({
          ...data,
          mac_address: data.macAddress,
        }),
      };

      const response = await axiosInstance.post(
        'i6ebECI5pq76FY1Sc9GH8MGcKvB34NJW',
        QueryString.stringify(body)
      );

      const responseData = decryptResponse(response.data);

      if (responseData.success) {
        enqueueSnackbar('Email sent successfully', { variant: 'success' });
        reset(defaultValues);
      } else {
        enqueueSnackbar(responseData.message, { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Server Error', { variant: 'error' });
    }
  });

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Stack
        sx={{
          minWidth: {
            lg: '600px',
          },
        }}
        gap={3}
      >
        <Stack flexDirection="row" gap={3}>
          <RHFTextField name="name" label="Name *" type="text" />
          <RHFTextField name="email" label="Email *" type="text" />
        </Stack>
        <Stack flexDirection="row" gap={3}>
          <RHFTextField name="phone" label="Phone" type="text" />
          <RHFTextField name="macAddress" label="Mac Address" type="text" />
        </Stack>
        <RHFTextField name="subject" label="Subject *" type="text" />
        <RHFTextField name="message" label="Message *" type="text" multiline rows={5} />
        <Box>
          <LoadingButton
            color="inherit"
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Send Message
          </LoadingButton>
        </Box>
      </Stack>
    </FormProvider>
  );
}
